module.exports = __webpack_public_path__ + "static/media/tc.8c0eb076.svg";